<app-navbar-style-two></app-navbar-style-two>
<app-partner></app-partner>

<!-- Start Page Title Area -->
<div class="page-title-area" *ngFor="let Content of pageTitle;" style="background-image: url({{Content.bgImage}});">
    <h1>{{Content.title}}</h1>
    <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{Content.title}}</li>
    </ul>
</div>
<!-- End Page Title Area -->

<!-- Start Clients Area -->
<section class="clients-area pt-100 pb-70">
    <div class="container">
        <div class="clients-content" *ngFor="let Content of clientsContent;">
            <div class="section-header text-center">
                <div class="section-badge">{{Content.subTitle}}</div>
                <h2 class="section-title">{{Content.title}}</h2>
                <p class="section-description">{{Content.paragraph}}</p>
            </div>

            <!-- Client Filter -->
            <div class="client-filter text-center mb-5">
                <button 
                    *ngFor="let category of clientCategories" 
                    class="filter-btn"
                    [class.active]="category.active"
                    (click)="filterClients(category.id)">
                    {{category.name}}
                </button>
            </div>

            <!-- Clients Grid -->
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-6 mb-4" *ngFor="let client of filteredClients;">
                    <div class="client-card">
                        <div class="client-logo">
                            <img [src]="client.logo" [alt]="client.name">
                        </div>
                        <div class="client-info">
                            <h4>{{client.name}}</h4>
                            <span class="client-sector">{{client.sector}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div class="text-center py-5" *ngIf="filteredClients.length === 0">
                <i class="bx bx-buildings" style="font-size: 64px; color: #ccc;"></i>
                <p class="mt-3 text-muted">No clients found in this category.</p>
            </div>
        </div>
    </div>
</section>
<!-- End Clients Area -->

<app-testimonials></app-testimonials>
